import { gql, useMutation } from "@apollo/client";

const SEND_LEAD_MUTATION = gql`
	mutation sendLead($input: LeadInput!) {
		sendLead(input: $input) {
			id
		}
	}
`;

export const useSendTextLead = ({
	property_id,
	entity_type,
	message,
	source,
	isAutoGenerated = false,
	financing_information,
}) => {
	const [sendLeadMutation, { loading }] = useMutation(SEND_LEAD_MUTATION, {
		onError: error => {
			console.log(error);
		},
	});

	const sendLead = async () => {
		let response = await sendLeadMutation({
			variables: {
				input: {
					type: entity_type,
					property_id,
					message,
					source,
					isAutoGenerated,
					financing_information,
				},
			},
		});

		return { success: response?.data?.sendLead?.id ? true : false };
	};

	return {
		loading,
		sendLead,
	};
};
